/** The next page, when there is one.
 *
 * Nothing is drawn once the cursor is gone: a listing that has shown its
 * last row should not keep offering more of it.
 */

import type { Paged, PagedListing } from './usePaged';

export interface LoadMoreProps<T, P extends Paged<T>> {
  listing: PagedListing<T, P>;
  label?: string;
}

export function LoadMore<T, P extends Paged<T>>({ listing, label = 'Load more' }: LoadMoreProps<T, P>) {
  if (!listing.cursor) return null;
  return (
    <div>
      <button
        type="button"
        className="btn btn-secondary"
        style={{ fontSize: 12 }}
        disabled={listing.loadingMore}
        onClick={listing.loadMore}
      >
        {listing.loadingMore ? 'Loading…' : label}
      </button>
    </div>
  );
}

export default LoadMore;
